export default __webpack_public_path__ + "./fonts/checkInfo.1378f91a.svg";